import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: '#525ca3',
        secondary: '#363636 ',
        accent: '#ffdd0e',
        error: '#b71c1c',
      },
    },
  },
});
